import React, {useState} from 'react';

import {Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Modal, Row} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {RotateCircleLoading} from "react-loadingg";
import {resource_strings} from "../../translations/resource_translations";
import dateHelpers from "../../helpers/DateHelper";
import resourceHelper from "../../helpers/ResourceHelper";
import constants from "../../shared/constants";
import ResourceApiService from "../../api/resource-api-service";

let alertStrings = new LocalizedStrings(alert_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const EditEventModal = (props) => {
    const [visible, setVisible] = useState(true);
    const [event, setEvent] = useState(props.event || resourceHelper.emptyEvent());
    const [isLoading, setIsLoading] = useState(false);

    const onDismiss = () => setVisible(false);

    function toggle(formModal) {
        setVisible(!visible);
        props.toggleModal();
    }

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    function updateEventDate(curEvent, value) {
        return dateHelpers.databaseDateTime(dateHelpers.setDateKeepTime(new Date(curEvent.time), value))
    }

    function updateEventTime(curEvent, value) {
        return dateHelpers.databaseDateTime(dateHelpers.setTimeKeepDate(new Date(curEvent.time), value))
    }

    const handleChange = (e) => {
        const curEvent = event;

        switch (e.target.id) {
            case "input-date":
                curEvent.time = updateEventDate(curEvent, e.target.value);
                break;
            case "input-time":
                curEvent.time = updateEventTime(curEvent, e.target.value);
                break;
            case "input-title":
                curEvent.title = e.target.value;
                break;
            case "input-body":
                curEvent.body = e.target.value;
                break;
            case "input-admin-cb":
                curEvent.admin_only = e.target.checked;
                break;
            case "input-remind-cb":
                curEvent.remind = e.target.checked;
                break;
            default:
                break;
        }
        setEvent(curEvent);
    };

    localize();

    function headerText() {
        if (!event.id) {
            return event.event_type === constants.events.event ? resourceStrings.events.new_event
                : resourceStrings.events.new_reminder;
        } else {
            return event.event_type === constants.events.event ? resourceStrings.events.edit_event
                : resourceStrings.events.edit_reminder;
        }
    }

    function deleteEvent(e) {
        setIsLoading(true);
        e.preventDefault();

        ResourceApiService.deleteEvent(event)
            .then(res => {
                setIsLoading(false);
                props.handleEventSaved(res)
            })
            .catch((e) => {
                props.handleError(e)
            });
    }

    function saveEvent(e) {
        setIsLoading(true);
        e.preventDefault();

        if (event.id) {
            ResourceApiService.updateEvent(event)
                .then(res => {
                    setIsLoading(false);
                    props.handleEventSaved(res)
                })
                .catch((e) => {
                    props.handleError(e)
                });
        } else {
            ResourceApiService.postEvent(event)
                .then(res => {
                    setIsLoading(false);
                    props.handleEventSaved(res)
                })
                .catch((e) => {
                    props.handleError(e)
                });
        }
    }

    return (
        <Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={visible}
            toggle={() => toggle("notificationModal")}
        >
            <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {isLoading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <Row className="align-items-center">
                        <div className="col">
                            <h2 className="text-white mb-0">{headerText()}</h2>
                        </div>

                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => toggle("notificationModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </Row>
                </CardHeader>
                <CardBody>

                    <Form>
                        <div className="pl-lg-12">

                            <Row>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-date"
                                        >
                                            {commonStrings.date}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={handleChange}
                                            defaultValue={dateHelpers.databaseDate(event.time)}
                                            id="input-date"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-time"
                                        >
                                            {commonStrings.time}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={handleChange}
                                            defaultValue={dateHelpers.stringTime(event.time)}
                                            id="input-time"
                                            type="time"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-title"
                                        >
                                            {resourceStrings.title}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={handleChange}
                                            defaultValue={event.title}
                                            id="input-title"
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-body"
                                        >
                                            {resourceStrings.description}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={handleChange}
                                            defaultValue={event.body}
                                            id="input-body"
                                            rows="3"
                                            type="textarea"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <div className="custom-control custom-checkbox"
                                             style={{position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}>
                                            <input
                                                className="custom-control-input"
                                                id="input-admin-cb"
                                                type="checkbox"
                                                onChange={handleChange}
                                                defaultChecked={event.admin_only === true}
                                            />
                                            <label className="custom-control-label" htmlFor="input-admin-cb">
                                                {resourceStrings.events.admin_only}
                                            </label>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>

                            {event.event_type === constants.events.reminder &&
                            <>
                                <Row>
                                    <Col lg="12">
                                        <FormGroup>
                                            <div className="custom-control custom-checkbox"
                                                 style={{
                                                     position: 'absolute',
                                                     top: '50%',
                                                     transform: 'translateY(-50%)'
                                                 }}>
                                                <input
                                                    className="custom-control-input"
                                                    id="input-remind-cb"
                                                    type="checkbox"
                                                    onChange={handleChange}
                                                    defaultChecked={event.remind === true}
                                                />
                                                <label className="custom-control-label" htmlFor="input-remind-cb">
                                                    {resourceStrings.events.remind}
                                                </label>
                                            </div>
                                        </FormGroup>

                                    </Col>
                                </Row>
                                <Row className="ml-4">
                                    <div>
                                        <small><i>{resourceStrings.events.remind_expl}</i></small>
                                    </div>
                                </Row>
                            </>
                            }

                            <Row>
                                <Col lg="12" className="text-right">
                                    {event.id &&
                                    <Button
                                        color={"danger"}
                                        type="button"
                                        size="lg"
                                        onClick={e => deleteEvent(e)}
                                    >
                                        {commonStrings.delete}
                                    </Button>
                                    }

                                    <Button
                                        color={"primary"}
                                        type="button"
                                        size="lg"
                                        onClick={e => saveEvent(e)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Modal>
    );
};

export default EditEventModal;